// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__at6Ml","noInteraction":"EventWrapper_noInteraction__f2nxN"};